import React, { useState } from 'react';

const data = () => {
    const [newData, setData] = useState("");
};

export {data};